import CommonList from '../../common/CommonList'
import './whatwedo.css'
export default function Whatwedo() {
  const listData = [
    {
      icon: "fa-user",
      title: "Consumer Insights",
      description: "We don’t just scratch the surface, we delve deep into your audience’s behaviour so you know the ‘why’ behind the ‘buy’"
    },
    {
      icon: "fa-shopping-cart",
      title: "Retail Real Estate Activation",
      description: "Know where to plant your flag for maximum footfall-no more guesswork!"
    },
    {
      icon: "fa-chart-bar",
      title: "Predictive Simulations",
      description: "Imagine forecasting sales volumes for the next three quarters like it’s child’s play. Yup, we make it that easy!"
    },
    {
      icon: "fa-bullhorn",
      title: "Marketing With Precision",
      description: "Launching a new product? Let’s ensure you hit the bullseye with the right audience, every time."
    }
  ]
    return(
        <section className="whatwedo">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <h2 className="title">We unlock growth for <span>your business</span>, 
                at every step</h2>
              </div>   
              <div className="col-md-6">
              {listData.map((item, index) => 
                <CommonList key={index} icon={item.icon} title={item.title} description={item.description} />
              )}

              </div>   
            </div>
          </div>
        </section>
    )
}